import featuredOffers502x272 from './FeaturedOffers502x272';

export default featuredOffers502x272;
